import { Button, Checkbox, Modal } from '@bfe/moly';
import { CloseIcon } from '@bfe/moly-icons';
import { invoke, isMobile, replaceVar, runAsyncSafe } from '@web3/utils';
import { useEffect, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { createCloudWallet } from '../../actions';
import { getDefaultIndex } from '../../store/config';
import { WalletCreatePanel, createWalletModalStore } from '../../store/dialogs';
import { useLocale } from '../../store/i18nMessage';
import { usePermission } from '../../store/permission';
import { useCloudWallet } from '../../store/userCloudWallet';
import { useUserInfo } from '../../store/userInfo';
import { walletGuideStorageKey } from '../../utils/constants';
import { scTrack } from '../../utils/scTrack';
import { isBrowser } from '../../utils/trick';
import { USER_AGREEMENT_LINK } from '../../utils/url';
import { useReferralCode } from '../Web3CreateWalletModal/saveReferral';
import createWalletImg from './images/create-wallet.svg';
import './style.scss';

export type Web3WalletGuideModalProps = {};

const storeStatus = isBrowser ? Number(window.localStorage.getItem(walletGuideStorageKey)) : 1;

const setStoredStatus = (status: number) => {
  if (isBrowser) {
    window.localStorage.setItem(walletGuideStorageKey, String(status));
  }
};

export function Web3WalletGuideModal(_props: Web3WalletGuideModalProps) {
  const { isLawRestricted } = usePermission();
  const { isLogin } = useUserInfo();
  const { hasCloudWallet } = useCloudWallet();
  // UI 逻辑上是否展示（操作）
  const [logicShow, setLogicShow] = useState(true);
  const { t, locale } = useLocale();

  // 展示创建钱包引导弹窗
  // 1. 加载完钱包地址后，没有创建过云钱包
  // 2. 没有提示过弹窗
  const show = invoke(() => logicShow && !isMobile && !isLawRestricted && isLogin && !hasCloudWallet && !storeStatus);

  const [agree, setAgree] = useState(true);

  const [createState, doCreateWallet] = useAsyncFn(async (referral: string) => {
    const [err] = await runAsyncSafe(createCloudWallet(referral.trim()));
    createWalletModalStore.show({
      panel: err ? WalletCreatePanel.Success : WalletCreatePanel.Failed,
    });
    scTrack('SpotWeb31stTimeWalletCreationPopUpResult', { result_code: err?.code });
    hide();
  }, []);

  const [referral, setReferral] = useReferralCode(show);

  useEffect(() => {
    if (show) {
      setStoredStatus(1);
      scTrack('SpotWeb31stTimeWalletCreationPopUpExposure', {});
    }
  }, [show]);

  if (!show) {
    return null;
  }
  const hide = () => {
    setLogicShow(false);
  };
  return (
    <Modal
      zIndex={getDefaultIndex()}
      open={show}
      width={780}
      title={null}
      footer={null}
      closable={false}
      className="web3-wallet-guide-modal"
      modal={false}
    >
      <div className="flex">
        <div className=" overflow-hidden pt-4 w-[470px] flex-shrink-0">
          <img src={createWalletImg} alt="" />
        </div>
        <div className="flex-col flex justify-between break-words bg-[#f5f7fa]">
          <div className="flex justify-end p-6">
            <button className="close-button svg-full" onClick={hide} data-spm-even="SpotWeb31stTimeWalletCreationPopUpClick" data-button_name="Close">
              <div className="svg-full size-6">
                <CloseIcon />
              </div>
            </button>
          </div>
          <div className="p-6 flex-1">
            <h2 className=" text-2xl font-semibold text-bds-static-black" dangerouslySetInnerHTML={{ __html: t('create_wallet_guide_title') }} />
            <p className=" text-sm text-bds-gray-t2 mt-2">{t('create_wallet_guide_desc')}</p>
          </div>
          <div className="p-6">
            <Button
              loading={createState.loading}
              variant="primary"
              block
              disabled={!agree}
              onClick={() => doCreateWallet(referral)}
              data-spm-even="SpotWeb31stTimeWalletCreationPopUpClick"
              data-button_name="Create"
            >
              {t('wallet_connect')}
            </Button>
            {/* 邀请码，由于@victory1.liu 需求改动，暂时不給用户展示邀请码，邀请逻辑保持不变*/}
            {/* <div className="mt-2">
              <p className="text-bds-gray-t3 text-xs">{t('web3ReferralCode')}</p>
              <Input
                value={referral}
                onChange={(e) => {
                  setReferral(e.target.value);
                }}
                placeholder={t('enterReferralCode')}
                size="xs"
                className="w-full !bg-white mt-1 border-transparent to-bds-static-black"
              />
            </div> */}
            <div className="flex mt-3">
              <Checkbox checked={agree} onChange={(v) => setAgree(!agree)} />
              <div
                className="text-xs agreement text-bds-static-black"
                dangerouslySetInnerHTML={{ __html: t('create_tips1', { url: replaceVar(USER_AGREEMENT_LINK, { locale }) }) }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
